/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Services_Streamer_TitleInputs */

const ja_playdata_home_services_streamer_title = /** @type {(inputs: Playdata_Home_Services_Streamer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストリーマーレポート`)
};

const en_playdata_home_services_streamer_title = /** @type {(inputs: Playdata_Home_Services_Streamer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streamer Report`)
};

/**
* | output |
* | --- |
* | "Streamer Report" |
*
* @param {Playdata_Home_Services_Streamer_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_services_streamer_title = /** @type {((inputs?: Playdata_Home_Services_Streamer_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Services_Streamer_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_services_streamer_title(inputs)
	return en_playdata_home_services_streamer_title(inputs)
});